export default __webpack_public_path__ + "static/media/blip-wink.221e374a.svg";